import { gql } from "graphql-tag";

export const GET_ANALYTICS_DEDUCTIONS_BY_AGING_BRACKETS = gql`
  query AnalyticsDeductionsByAgingBrackets($params: GetAnalyticsInput!) {
    analyticsDeductionsByAgingBrackets(params: $params) {
      allOpen {
        totalAmount
        totalCount
        brackets {
          bracketKey
          bracketLabel
          minDays
          maxDays
          amount
          count
          share
        }
      }
      inDispute {
        totalAmount
        totalCount
        brackets {
          bracketKey
          bracketLabel
          amount
          count
          share
        }
      }
    }
  }
`;
